import { useState, useCallback } from "react";
import { URL_CONSTANTS } from "../../axios/urlLinksThemes";
import { httpGet } from "../../axios/axiosUtils";
import {
  getTokenFromMeta,
  setBussinessToken,
} from "../../shared/helpersMethod";

const useGetToken = () => {
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState<string>();
  const [userId, setUserId] = useState<number>();
  const [tokenFetched, setTokenFetched] = useState(false);

  const getToken = useCallback(
    async (isExpired = false): Promise<string> => {
      // Prevent multiple simultaneous calls
      if (loading) {
        console.log("Token fetch already in progress");
        return accessToken || "";
      }

      setLoading(true);

      try {
        const metaToken = getTokenFromMeta();
        console.log(
          "🔐 Token fetch - isExpired:",
          isExpired,
          "metaToken:",
          metaToken
        );

        // Check if we can use the meta token (only if not expired)
        if (
          !isExpired &&
          metaToken &&
          metaToken !== "null" &&
          metaToken !== null &&
          metaToken !== "{dukanyToken}" &&
          metaToken.trim() !== ""
        ) {
          console.log("✅ Using meta token:", metaToken);
          setAccessToken(metaToken);
          setBussinessToken(metaToken);
          setTokenFetched(true);
          setLoading(false);
          return metaToken;
        }

        // If we already have a valid token and it's not expired, use it
        if (!isExpired && accessToken && tokenFetched) {
          console.log("✅ Using existing token:", accessToken);
          setLoading(false);
          return accessToken;
        }

        // Fetch new token from API
        const domainName = window.businessByDomain;
        console.log("🌐 Fetching new token for domain:", domainName);

        if (!domainName || domainName === "Unknown") {
          throw new Error("Invalid domain name");
        }

        const res = await httpGet(
          URL_CONSTANTS.get("URL_GET_TOKEN")! + domainName
        );

        if (res?.data?.access_token) {
          const newToken = res.data.access_token;
          console.log("✅ New token fetched successfully");

          setAccessToken(newToken);
          setUserId(res.user_id);
          setBussinessToken(newToken);
          setTokenFetched(true);
          setLoading(false);

          console.log("🔄 Token updated in storage");
          return newToken;
        } else {
          throw new Error("Invalid token response");
        }
      } catch (error: any) {
        console.error("❌ Token fetch error:", error.message);
        setLoading(false);
        setTokenFetched(true); // Prevent infinite retries
        throw error;
      }
    },
    [loading, accessToken, tokenFetched]
  );

  return {
    getToken,
    accessToken,
    userId,
    loading,
    tokenFetched,
  };
};

export default useGetToken;
